var generateOrganizationNavigator;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import OrganizationHierarchicalList from './organization_navigator_list/organization_hierarchical_list.js';

import CreateOrganizationModal from 'trunks/vue/admin/compositions/organizations/responses/create_organization_modal.js';

import UpdateOrganizationModal from 'trunks/vue/admin/compositions/organizations/responses/update_organization_modal.js';

import OrganizationSearchItem from 'trunks/vue/admin/compositions/organizations_sidebar/sidebar_search/organization_search_item.js';

export var OrganizationNavigator = Vue.extend({
  components: {
    "organization-hierarchical-list": OrganizationHierarchicalList,
    "organization-search-item": OrganizationSearchItem
  },
  props: {
    initSelectedOrganizationId: {
      type: String
    },
    searchCallback: {
      type: Function
    },
    query: {
      type: String
    }
  },
  data: function() {
    return {
      resources: '/admin/organizations',
      readonly: false,
      selectedOrganizationId: this.initSelectedOrganizationId,
      profileSchema: null,
      searchValue: this.query,
      organizationSearchList: [],
      selectedSearchOrganization: {},
      listItemSelected: true,
      autofocus: false,
      scrollTop: 0
    };
  },
  template: `<div class="sidebar-organization" data-has-navigator>
  <div class="input-control left-addon">
    <input  type="text"
            class="controlled-input floated"
            v-model.trim="searchValue"
            placeholder="搜索组织或成员"
            :autofocus="autofocus">
    <div class="addon">
      <i class="slp-search"></i>
    </div>
  </div>
  <div class="search-list" v-if="searchValue">
    <div class="members-search-list">
      <div class="list-title">成员</div>
      <div class="list-item" :class="{ selected: listItemSelected }" @click="goToSearchMembers">相关成员</div>
    </div>
    <div class="organizations-search-list">
      <div class="list-title">组织</div>
      <div class="organizations-search-wrapper">
        <organization-search-item v-for="organization in organizationSearchList"
                                  :key="organization.id"
                                  :organization="organization"
                                  :selectedSearchOrganization="selectedSearchOrganization"
                                  @selectedSearchOrganizationFunc="selectedSearchOrganizationFunc"/>
      </div>
    </div>
  </div>
  <div class="sidebar-content" v-else>
    <div class="list">
      <div class="list-title">成员</div>
      <div class="content">
        <div class="list-item"
            :class='membersClass'
            @click="goToAllUsersPage">
          <i class="slp-users-o"></i>
          <span>所有成员</span>
        </div>
        <div class="list-item"
            :class='suspendedMembersClass'
            @click="getUsersNotInOrganization">
          <i class="slp-users-times-o"></i>
          <span>未在组织成员</span>
        </div>
      </div>
    </div>
    <div class="organizations-list">
      <div class="list-head">
        <div class="list-title">组织</div>
        <button class="text-btn btn-primary" @click="createTopOrganization">
          <i class="slp-plus-circle"></i>
          <span>创建顶级组织</span>
        </button>
        <a href="/admin/organization_profile/schema" target="_blank" class="btn icon-btn link-btn"><i class="slp-setting-o"></i></a>
      </div>
      <div class="list-body"
           @scroll="sidebarScrollFunc"
           ref="sidebarContentRef">
        <organization-hierarchical-list
          :resources='resources'
          :initialSelectedNodeId='selectedHierarchicalOrganizationId'
          :readonly='readonly'
          :profileSchema='profileSchema'
          @organizationSelected='updateSelectedOrganizationId'
          ref='organizationsSelect' />
      </div>
    </div>
  </div>
</div>`,
  created: function() {
    this._getProsfileSchema();
    return this._getSearchOrganizations();
  },
  mounted: function() {
    return document.addEventListener('turbolinks:render', this._setSidebarScrollTop, false);
  },
  destroyed: function() {
    return document.removeEventListener('turbolinks:render', this._setSidebarScrollTop, false);
  },
  computed: {
    membersClass: function() {
      return {
        selected: this.selectedOrganizationId === 'members'
      };
    },
    suspendedMembersClass: function() {
      return {
        selected: this.selectedOrganizationId === 'suspended_members'
      };
    },
    hierarchy: function() {
      var ref;
      return (ref = this.$refs.organizationsSelect) != null ? ref.hierarchy : void 0;
    },
    selectedHierarchicalOrganizationId: function() {
      if (_.contains(["members", "suspended_members"], this.selectedOrganizationId)) {
        return '';
      } else {
        return this.selectedOrganizationId;
      }
    }
  },
  watch: {
    searchValue: _.debounce(function(newValue, oldValue) {
      if (oldValue || newValue) {
        this.autofocus = true;
      } else {
        this.autofocus = false;
      }
      this.listItemSelected = true;
      this.showSearchList = true;
      this._getSearchOrganizations();
      if (this.searchValue) {
        return this.goToSearchMembers();
      } else {
        return this.goToAllUsersPage();
      }
    }, 300),
    selectedOrganizationId: function(id) {
      switch (id) {
        case 'members':
          return Turbolinks.visit("/admin/users");
        case 'suspended_members':
          this.autofocus = false;
          return Turbolinks.visit("/admin/users/suspended");
        default:
          this.autofocus = false;
          return Turbolinks.visit(`/admin/organizations/${id}/members`);
      }
    }
  },
  methods: {
    goToSearchMembers: function() {
      this.listItemSelected = true;
      this._resetSelectedSearchOrganization();
      return Turbolinks.visit(`/admin/users?query=${this.searchValue}`);
    },
    selectedSearchOrganizationFunc: function(selectedSearchOrganization) {
      this.selectedSearchOrganization = selectedSearchOrganization;
      this.listItemSelected = false;
      return Turbolinks.visit(`/admin/organizations/${selectedSearchOrganization.id}/members`);
    },
    updateSelectedOrganizationId: function(option) {
      return this.selectedOrganizationId = option.id;
    },
    goToAllUsersPage: function() {
      this.selectedOrganizationId = 'members';
      Turbolinks.visit("/admin/users");
      return this._resetSelectedSearchOrganization();
    },
    getUsersNotInOrganization: function() {
      this.selectedOrganizationId = 'suspended_members';
      return Turbolinks.visit("/admin/users/suspended");
    },
    createTopOrganization: function() {
      return new CreateOrganizationModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('create_top_organization_modal_container'),
        propsData: {
          profileSchema: this.profileSchema,
          childrenAddCallback: (raw_organization) => {
            return this.$refs.organizationsSelect.hierarchy.addNodes([raw_organization]);
          }
        }
      });
    },
    openUpdateOrganizationModal: function(organization, cb) {
      return new UpdateOrganizationModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('create_organization_modal_container'),
        propsData: {
          profileSchema: this.profileSchema,
          organization: organization,
          action: 'edit_description',
          editOrganizationEditorExtendClass: ["update-description-editor"],
          updateOrganizationFunc: function() {
            return typeof cb === "function" ? cb() : void 0;
          }
        }
      });
    },
    openUpdateProfileModal: function(organization, cb) {
      return new UpdateOrganizationModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('update_profile_modal_container'),
        propsData: {
          profileSchema: this.profileSchema,
          organization: organization,
          action: 'edit_profile',
          updateOrganizationFunc: function() {
            return typeof cb === "function" ? cb() : void 0;
          }
        }
      });
    },
    sidebarScrollFunc: function(e) {
      return this.scrollTop = e.target.scrollTop;
    },
    _setSidebarScrollTop: function() {
      if (this.$refs.sidebarContentRef) {
        return this.$refs.sidebarContentRef.scrollTop = this.scrollTop;
      }
    },
    _resetSelectedSearchOrganization: function() {
      return this.selectedSearchOrganization = {};
    },
    _getProsfileSchema: function() {
      return Skylark.Libs.Ajax.get("/admin/organization_profile/schema.json", {
        responseType: 'json',
        success: (data) => {
          return this.profileSchema = new Skylark.App.Model.OrganizationProfile.Schema(data);
        }
      });
    },
    _getSearchOrganizations: function() {
      return Skylark.Libs.Ajax.get(`/admin/organizations/query?name=${this.searchValue}`, {
        responseType: 'json',
        success: (res) => {
          return this.organizationSearchList = res.data;
        }
      });
    }
  }
});

export default generateOrganizationNavigator = {
  _generateOrganizationSidebarView: function(id, query) {
    var navigator_el;
    navigator_el = DomMaster.find('[data-has-navigator]');
    return this.sidebarVm = navigator_el.isPresent() ? navigator_el.node.__vue__ : new OrganizationNavigator({
      el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('organization-menu'),
      propsData: {
        initSelectedOrganizationId: id,
        query: query
      }
    });
  }
};
